<template>
    <div class="c-services">
        <div class="c-services__item" v-for="service in services" :key="service.id" v-on:click="selectService(service.id,service.name)" v-bind:class="isServiceSelected(service.id)">
            <span class="c-services__imageWrap">
                <span>
                    <img :src="service.image" :alt="service.name" class="c-services__image">
                </span>
            </span>
            <span class="c-services__label">
                {{ service.name }}
            </span>
        </div>
    </div>
</template>
<script>
    export default {
       data(){
           return {
               selectedIDS:[],
               selectedNames:[],
               services:[
                    {
                        id:1,
                        name:'Przegląd okresowy',
                        image:require('../assets/images/przegląd-okresowy.jpg')
                    },
                    {
                       id:2,
                       name:'Czyszczenie klimatyzacji',
                       image:require('../assets/images/czyszczenie-klimatyzacji.jpg')
                    },
                    {
                       id:3,
                       name:'Wymiana opon/kół',
                       image:require('../assets/images/wymiana-opon-i-kol.jpg')
                    },
                    {
                       id:4,
                       name:'Naprawa elektryczna',
                       image:require('../assets/images/naprawa-elektryczna.jpg')
                    },
                    {
                       id:5,
                       name:'Naprawa mechaniczna',
                       image:require('../assets/images/nampawa-mechaniczna.jpg')
                    },
                    {
                       id:6,
                       name:'Inne',
                       image:require('../assets/images/inne.jpg')
                    }
               ]
           }
       },
       methods:{
            isServiceSelected(id){
                return this.selectedIDS.includes(id) ?'c-services__item--selected':''
            },
            selectService(id,name){
                this.selectedNames.includes(name)?this.selectedNames = this.selectedNames.filter(e => e != name):this.selectedNames.push(name);
                this.selectedIDS.includes(id)?this.selectedIDS = this.selectedIDS.filter(e => e != id):this.selectedIDS.push(id);
                this.$emit('selectService',this.selectedNames);
                if(this.selectedIDS.length > 0){
                    this.$emit('isValid',true)
                }
            }
       }
    }
</script>
<style lang="scss">
    @import '../_variables.scss';
    .c-services{
        display: flex;
        flex-wrap: wrap;
        @media(min-width: 780px){
            flex-wrap: nowrap;
            display: flex;
            justify-content: space-between;
        }
        &__item{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            padding: 1rem;
            width:50%;
            position: relative;
            @media(min-width: 780px){
                width: 100%
            }
            cursor: pointer;
            &::after{
                content: ' ';
                display: block;
                position: absolute;
                top: -1rem;
                left: -1rem;
                right: -1rem;
                bottom: -1rem;
                border: 1px solid $darkLazuri;
                border-radius: .5rem;
                transition: all .5s;
                opacity: 0;
            }
            &--selected{
                &::after{
                    top: .25rem;
                    left: .25rem;
                    right: .25rem;
                    bottom: .25rem;
                    opacity: 1;
                }
            }
        }
        &__imageWrap{
            height: 99px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }   
        &__image{   
            max-height: 99px;
            width: auto;
            margin-bottom: 1rem;
        }
        &__label{
            max-width: 135px;
            display: inline-block;
            text-align: center;
        }
    }
</style>